import React from "react";

// SHIOKOI brand logo (stacked: monogram + wordmark + tagline). Transparent PNGs in /public.
// tone: "white" for dark backgrounds/photos, "dark" for light backgrounds.
export const Logo = ({ tone = "white", className = "h-10 w-auto", ...props }) => {
  const src = tone === "dark" ? "/shiokoi-logo-dark.png" : "/shiokoi-logo-white.png";
  return <img src={src} alt="SHIOKOI" className={className} draggable="false" {...props} />;
};
